import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2579d42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "code-input-wrapper" }
const _hoisted_2 = { class: "code-inputs" }
const _hoisted_3 = ["value", "onInput", "onKeydown"]

import { ref, nextTick, watch, ComponentPublicInstance } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string }




const DIGIT_COUNT = 8;
const code = ref<string[]>(Array(DIGIT_COUNT).fill(''));
const inputs = ref<(HTMLInputElement | null)[]>([]);

function setInputRef(el: Element | ComponentPublicInstance | null, idx: number) {
  if (el instanceof HTMLInputElement || el === null) {
    inputs.value[idx] = el;
  }
}

watch(
  () => props.modelValue,
  (newVal) => {
    // Only update if the new value is different from current joined code
    const currentCode = code.value.join('');
    if (newVal !== currentCode) {
      if (newVal && newVal.length === DIGIT_COUNT) {
        code.value = newVal.split('');
      } else if (newVal === '') {
        code.value = Array(DIGIT_COUNT).fill('');
      }
    }
  },
  { immediate: true }
);

function onInput(e: Event, idx: number) {
  const input = e.target as HTMLInputElement;
  let val = input.value.replace(/[^a-zA-Z0-9]/g, '');
  if (val.length > 1) {
    val = val.slice(-1);
  }

  // Create a new array to ensure reactivity
  const newCode = [...code.value];
  newCode[idx] = val;
  code.value = newCode;

  if (val && idx < DIGIT_COUNT - 1) {
    nextTick(() => inputs.value[idx + 1]?.focus());
  }

  emit('update:modelValue', code.value.join(''));
}

function onKeydown(e: KeyboardEvent, idx: number) {
  if (e.key === 'Backspace' && !code.value[idx] && idx > 0) {
    nextTick(() => inputs.value[idx - 1]?.focus());
  } else if (e.key === 'Enter') {
    const currentCode = code.value.join('');
    emit('submit', currentCode);
  }
}

// handlePaste function removed as it was not being used

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(code.value, (digit, idx) => {
        return (_openBlock(), _createElementBlock("input", {
          key: idx,
          ref_for: true,
          ref: el => setInputRef(el, idx),
          value: code.value[idx],
          type: "text",
          inputmode: "text",
          maxlength: "1",
          class: "code-input",
          autocomplete: "one-time-code",
          onInput: e => onInput(e, idx),
          onKeydown: e => onKeydown(e, idx)
        }, null, 40, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})